import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { useFormikContext } from 'formik'

import { useDateLocale, useTimeZone } from '../../../../../hooks'
import { DatePicker } from '../../../../DateTime'
import { FieldStackedLabel } from '../../../../Field'
import { FormikField } from '../../../../Formik'
import Text from '../../../../Text'
import { useCalendarDayLoad } from '../../../Calendar.hooks'
import {
  CALENDAR_RELIEVE_DAY_FIELD_NAME_DATE,
  CALENDAR_RELIEVE_DAY_FIELD_NAME_FOLLOW_UP_IDS,
  QA_NAME_CALENDAR_RELIEVE_DAY_TARGET_LOAD,
} from '../../CalendarRelieveDayModal.constants'
import { getCalendarRelieveDayTargetDate } from '../../CalendarRelieveDayModal.utils'

import { getCalendarRelieveDayTargetHint } from './TargetDayField.utils'

import * as styles from './TargetDayField.module.css'

function TargetDayField({ day, nextFreeDay }) {
  const { t } = useTranslation()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  const { values } = useFormikContext()

  const targetDate = getCalendarRelieveDayTargetDate({ timezone, values })

  const targetLoad = useCalendarDayLoad(targetDate)

  const targetHint = getCalendarRelieveDayTargetHint({
    day,
    locale,
    nextFreeDay,
    selectedCount: values[CALENDAR_RELIEVE_DAY_FIELD_NAME_FOLLOW_UP_IDS].length,
    t,
    targetDate,
    targetLoad,
  })

  return (
    <div className={styles.TargetDayField}>
      <FormikField
        Component={DatePicker}
        Field={FieldStackedLabel}
        fieldComponentProps={{
          label: t('Calendar.RelieveDayTargetKey'),
          required: true,
        }}
        name={CALENDAR_RELIEVE_DAY_FIELD_NAME_DATE}
        placeholder={t('Common.DatePickerAddDateKey')}
      />
      {targetHint ? (
        <Text
          className={classNames({ [styles.hintFull]: targetHint.isFull })}
          isSecondary={!targetHint.isFull}
          qaName={QA_NAME_CALENDAR_RELIEVE_DAY_TARGET_LOAD}
        >
          {targetHint.text}
        </Text>
      ) : null}
    </div>
  )
}

export default TargetDayField
